module.exports = __webpack_public_path__ + "static/img/11.271a886.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msbl/11.jpg
// module id = bRUi
// module chunks = 1